import type { Category } from '../types/product';
import { IMG } from './images';

export const categories: Category[] = [
  { id: 'home-batteries', name: 'Thuisbatterijen', description: 'Sla zonnestroom op voor de avond', image: IMG.home, fromPrice: 2149 },
  { id: 'plug-in', name: 'Plug-in batterijen', description: 'Geen installateur nodig', image: IMG.plugin, fromPrice: 649 },
  { id: 'power-stations', name: 'Powerstations', description: 'Kamperen, noodstroom & off-grid', image: IMG.station, fromPrice: 199 },
  { id: 'solar-panels', name: 'Zonnepanelen', description: 'Full black & TOPCon', image: IMG.solar, fromPrice: 99 },
  { id: 'inverters', name: 'Omvormers', description: 'Hybride & off-grid', image: IMG.inverter, fromPrice: 1190 },
  { id: 'accessories', name: 'Accessoires', description: 'Kabels, meters & montage', image: IMG.accessory, fromPrice: 24.95 },
];
